enum OsVariant {
  DEBIAN = 'DEBIAN',
  TORIZON = 'TORIZON',
}

export default OsVariant;
